// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'element-ui/lib/theme-default/index.css';
import Vue from 'vue';
import "babel-polyfill";
import router from './router';
import store from './store/';
import axios from 'axios';
import VueAxios from 'vue-axios';
import ElementUI from 'element-ui';
import VuePreview from 'vue-preview';
import { Message } from 'element-ui';
import ztxConfirm from './components/Confirm';
import ztxConfirmH from './components/ConfirmH';
import App from './App';

require('es6-promise').polyfill();

Vue.use(VueAxios, axios);
Vue.use(ElementUI);
Vue.use(VuePreview);
Vue.config.productionTip = true;
Vue.use(ztxConfirm);
Vue.use(ztxConfirmH);
const out_101 = [ // 排除101报错的接口
  '/hr/reg/simple', '/hr/modifyAndBind'
];
const isInFn = (url) => {
  const findOne = out_101.find(a => {
    return url.indexOf(a) > -1;
  });
  return findOne && findOne.length;
};

axios.interceptors.response.use(
  response => {
    if (response.status * 1 === 200) {
      let rdata = response.data;
      const responseURL = response.request.responseURL;
      const isIn = isInFn(responseURL);
      if (rdata.status * 1 === 100) {
        Message({
          message: "请登录",
          type: 'warning'
        });
        setTimeout(_ => {
          router.replace({
            path: '/login'
          });
          window.location.reload();
        }, 1000)
      } else if (rdata.status * 1 === 101 && isIn) {
        router.replace({
          path: '/login/select'
        });
      } else if (rdata.status * 1 === 200 || isIn) {

      } else if (rdata.status * 1 === 598) {
        Message({
          message: rdata.msg,
          type: 'warning'
        });
        router.replace({
          path: '/login/register'
        });
      } else if (rdata.status === undefined) {

      } else {
        Message({
          message: rdata.msg,
          type: 'warning'
        });
      }
      return response.data;
    }
  }
);
axios.interceptors.request.use(
  config => {
    if (config.url.indexOf('?') > -1) {
      config.url = config.url + '&t=' + Date.now();
    } else {
      config.url = config.url + '?t=' + Date.now();
    }
    return config;
  }
);

const goindex = (id) => {
  let url = `/wapi/hr/swichCompany?companyId=${id}`;
  axios.get(url).then(res => {
    if (this && this.$confirm) {
      this.$message({
        type: 'success',
        message: '登录成功',
        duration: 1500
      });
    }
    setTimeout(() => {
      if (res.status * 1 === 200) {
        router.replace('/index/home/index');
      }
    }, 1000);
  });
};

const getCompany = () => {
  axios.get("/wapi/hr/listCompany").then(res => {
    if (res.status * 1 === 200) {
      if (!res.data) {
        if (this && this.$confirm) {
          this.$confirm('您还没有加入任何企业或者没有可用企业，请创建或加入一家企业或咨询客服', '已登录', {
            confirmButtonText: '加入/注册企业',
            cancelButtonText: "我知道了"
          }).then(() => {
            router.replace('/register/join')
          });
        } else {
          router.replace('/register/join');
        }
      } else {
        if (res.data.length === 1) {
          goindex(res.data[0].companyId);
        } else {
          router.replace('/login/select');
        }
      }
    }
  });
};

router.beforeEach(async (to, from, next) => {
  if (to.path === '/login' && window.location.href.includes('?code')) {
    const code = window.location.href.split('?code=')[1];
    // await getTokenByCode(code);
    await axios.get(`/wapi/third/ysy/callback/?code=${code}`);
    getCompany();
    // next();
  } else {
    if (from.path === '/index/posts/edit' && to.path === '/index/posts/release') {
      window.location.reload();
    }
    if (to.fullPath.includes('resume/seeinfo') || to.fullPath.includes('searchlist')) {
      store.commit("targetShow", 'isresumeInfo');
    } else {
      store.commit("targetShow", 'noresumeInfo');
    }
    if (store.state.hrinfo && store.state.hrinfo.name) {
      if (to.meta.needlogin === 1) {
        router.replace('/index/home/index');
      }
    }
    next();
  }
});

Vue.config.productionTip = false;
// eslint-disable
// eslint-disable no-new
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App
  }
});



// WEBPACK FOOTER //
// ./src/main.js